import React from 'react';

/** Salto solo en espacios; cada token conserva su ancho natural (sin min/max width). */
export default function TableHeaderLabel({text}: {text: string}) {
  const parts = String(text ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length <= 1) return <>{text}</>;
  return (
    <>
      {parts.map((part, index) => (
        <React.Fragment key={`${part}-${index}`}>
          {index > 0 ? <br /> : null}
          {part}
        </React.Fragment>
      ))}
    </>
  );
}
